import './SearchableInput.scss';
import React, {  useState, useEffect, useRef } from "react";
import Storage from "../../../helpers/Storage";
import {connect} from 'react-redux';
import snippets from "../../../helpers/snippets";
import {withRouter} from "../../../helpers/withRouter";
import {default as _} from '../../../helpers/Translate';


function SearchableInput(props) {
    const [language] = useState(Storage.getLanguage())

    const [query, setQuery] = useState('')
    const [direction, setDirection] = useState(props.direction)
    const [isOpen, setIsOpen] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [selected, setSelected] = useState( props.defaultValue )
    const [hovered, setHovered] = useState()
    const [options, setOptions] = useState(props.options)
    const [resOptions, setResOptions] = useState(props.options)
    const containerRef = useRef(null);


    const onChange=(e)=>{
        props.onChange(e.value, props?.name)
    }

    useEffect(() => {
        setDisabled(props.disable)
        setSelected(props.defaultValue );
        setHovered(props.defaultValue );
        props.options.forEach((item) => item.text = _.init(item.text, language));
        setOptions(props.options);
        setResOptions(props.options)
        if (!snippets.isObjectEmpty(options )) {
            let t = options.find(item => item.value === props.defaultValue)
            if (t && !snippets.isObjectEmpty(t)) {
                setQuery(t.text)
            } else{
                let t = options.find(item => item.value === -1)
                itemClick(t)
            }
        }
    }, [props.options, props.disable, props.defaultValue,  options]);

    useEffect(() => {
        setDirection(props.direction ?? Storage.directionGet())
    }, [props.direction]);

    useEffect(() => {
        if (containerRef.current) {
            const container = containerRef.current;
            let index = resOptions.map((item)=>item.value === hovered ).indexOf(true)
            const item = container.children[index];

            if (item) {
                item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        }
    }, [hovered]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                EscFunc()
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        // document.addEventListener('click', clickOut);
        return () => {
            // document.removeEventListener('click', clickOut);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, containerRef]);

    useEffect(() => {
        let res
        if (!snippets.isObjectEmpty(query) && !snippets.isObjectEmpty(options)) {
            res = options.filter(item => item.text.toLowerCase().includes(query.toLowerCase()))
            if (snippets.isObjectEmpty(res)) {res = options.filter(item => item.value === -1)}
            if (res.length >= 1) {
                setHovered(res[0].value)
            }
        } else {
            res = options
        }
        setResOptions(res)
    }, [query]);

    const arrowClicked=()=>{
        if (disabled) {return}
        setIsOpen(!isOpen)
        if (isOpen){
            if (query === "") {EscFunc()}
        } else {
            setQuery("")
        }
    }

    const itemClick = (item) => {
        setSelected(item.value)
        setHovered(item.value)
        setQuery(item.text)
        onChange(item)
        setIsOpen(false)
    }

    const handleKeyDown = (e) => {
        if (disabled) {return}
        let currentIndex = resOptions.map((item)=>item.value === hovered ).indexOf(true)
        if (e.key === 'Tab' || e.key === 'Enter') {
            e.preventDefault();
            handleEnterBtn()
        } else if (e.key === 'ArrowUp' && isOpen) {
            e.preventDefault();
            setHovered(resOptions[(currentIndex - 1 + resOptions.length) % resOptions.length].value);
        } else if (e.key === 'ArrowDown' && isOpen) {
            e.preventDefault();
            setHovered(resOptions[(currentIndex + 1) % resOptions.length].value);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            EscFunc()
        }
    };

     const handleEnterBtn=()=>{
         let t = options.find((item)=>item.value === hovered )
         let in_it = resOptions.map(item => item.value === t.value).indexOf(true)
         if (!isOpen && query === options.find(item => item.value === selected).text){arrowClicked()} //for opening dropdown with enter
         else if (isOpen && resOptions.length >= 1 && in_it !== -1 ) {
             itemClick(t)
         }
         else {EscFunc()}
     }

    const EscFunc = () =>{
        setIsOpen(false)
        if (!snippets.isObjectEmpty(options)) {
            let t = options.find(item => item.value === selected)
            setQuery(t.text)
            setSelected(t.value)
            setHovered(t.value)
        }
    }

    return (
        <>
            <div className={`dropdown`}>
                <div className="control">
                    <div className="selected-value" onKeyDown={handleKeyDown}
                    >
                        <input
                            className={`${disabled ? "disabled" : ""}`}
                            type="text"
                            name="searchTerm"
                            onChange={(e) => {
                                setQuery(e.target.value)
                                !disabled && setIsOpen(true)
                            }}
                            value={query}
                            onClick={()=>arrowClicked()}
                            disabled={disabled}
                        />
                        <div className={`arrow_up_down ${direction}`} onClick={()=>arrowClicked()}
                        >
                            {isOpen
                                ? <i className="fa fa-angle-up" />
                                : <i className="fa fa-angle-down" />}
                        </div>
                    </div>

                    {(!disabled && isOpen) && <div className={`options ${isOpen ? "open" : ""} ${direction}`} ref={containerRef} >
                        {resOptions.map((item, index) => {
                            return (
                                <div className={`options_res ${item.value === selected ? "selected" : ""} ${item.value === hovered ? "hovered" : ""}`}
                                     onClick={() => itemClick(item)}
                                     onMouseOver={()=>setHovered(item.value)}
                                     key={`${index}`}
                                >
                                    {item.text}
                                </div>
                            );
                        })}
                    </div>
                    }
                </div>

            </div>
        </>
    )
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(withRouter(SearchableInput));